/**
 * Comment nommer la provenance d'un code lu par la tablette.
 *
 * Nicolas, 16/09 : « c'est inscrit Data Matrix, il faudrait inscrire
 * "e-ordo" [...] et ne pas utiliser le meme bouton "Identite INS" ». La
 * tablette enregistre desormais la source reelle sur `insReading.source` ;
 * ici on la traduit en titre.
 *
 * Les rendez-vous d'avant le 16/09 portent « Ordo numerique » et ceux qui
 * n'ont pas de source du tout sont des Datamatrix INS : c'est ce que la
 * tablette ecrivait alors, on ne reecrit pas le passe.
 */

export const SOURCE_INS = "Data Matrix";
export const SOURCE_ORDO = "e-ordo";
export const SOURCE_CNI = "CNI";
export const SOURCE_PASSEPORT = "Passeport";

/** Le nom du code, tel qu'on l'ecrit sur un bouton ou un titre de fenetre. */
export function titreSourceCode(source) {
  const s = String(source || "").trim();
  if (!s) return "Identité INS";
  if (s === "Ordo numérique" || s === "Ordo numerique" || s === SOURCE_ORDO) {
    return SOURCE_ORDO;
  }
  if (s === SOURCE_CNI) return "CNI";
  if (s === SOURCE_PASSEPORT) return "Passeport";
  if (s.includes("Data Matrix")) return "Identité INS";
  return s;
}

/**
 * La classe CSS d'une pastille de provenance.
 *
 * Nicolas, 16/09 : « les chips pour CNI et e-ordo ont la meme couleur que le
 * manuel, peux-tu les afficher egalement en Violet, comme ca le violet est
 * associe aux lectures automatiques ».
 *
 * C'est donc une regle et non une liste de couleurs : le violet (`nir`, son
 * nom d'origine) dit « une machine a lu ce champ », quel que soit le code —
 * Datamatrix INS, CNI, passeport, e-ordo. Le bleu reste la saisie humaine.
 * Toute nouvelle source lue par un code doit rejoindre cette ligne.
 */
export function classeSourceCode(source) {
  const s = String(source || "");
  if (!s) return "";
  if (
    s === SOURCE_CNI
    || s === SOURCE_PASSEPORT
    || s === SOURCE_ORDO
    || s.startsWith("Ordo num")
    || s.includes("Data Matrix")
    || s.includes("NIR")
  ) {
    return "nir";
  }
  if (s.includes("Carte vitale")) return "carte-vitale";
  if (s.includes("IA")) return "ia";
  if (s.includes("Patient")) return "patient";
  return "patient";
}
